import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { useSelector, useDispatch } from "react-redux";
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";


const api = axios.create({
    baseURL: 'InventoryMasterDetails'
})

const apiSlip = axios.create({
    baseURL: 'InventoryAudit'
})

export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
export const tableIconsInputScreen = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => (
        <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Clear: forwardRef((props, ref) => (
        <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
        <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);
const data = [
    {
        id: "12345678",
        firstName: "HYDERABAD",
        lastName: "16.5",
        emailId: "sriyanka",
        phone: "9/01/2023  ",

    }
];


export default function ViewAuditInventory(props) {
    //const classes = useStyles();
    

    //for progress
    var columns = [
        { title: "Audit Slip Number", field: "auditSlipNumber" },
        { title: "User Slip Number", field: "slipnumber" },
        { title: "Plant Id", field: "plantName" },
        { title: "Location", field: "locationName" },
        { title: "Material Number", field: "material" },
        { title: "Material Name", field: "materialDescription" },
        { title: "Class", field: "abcclassiification" },
        { title: "Unit Of Measure", field: "unitOfMeasurement" },
        { title: "Initial Quantity", field: "countedPhyQuantity", type: 'numeric', align: 'right'},
        { title: "Audited Quantity", field: "auditedQuantity", type: 'numeric', align: 'right' },
        { title: "Difference", field: "mismatchQuantity", type: 'numeric', align: 'right'},
        { title: "Comment", field: "remarks" },
        { title: "Audited By", field: "auditeddBy" },
        { title: "Audited On", field: "createdDate" },

    ];

    const [openLoader, setopenLoader] = useState(false);

    //for Warning showing
    const [openWarning, setopenWarning] = useState(false);
    const [openAlertWarning, setopenAlertWarning] = useState("");
    const [openClassNameWarning, setopenClassNameWarning] = useState("");
    const [openTypeWarning, setopenTypeWarning] = useState("");
    const [alertwarningclass, setalertwarningclass] = useState("bg-amber clr-white");
    const [alertwarning, setalertwarning] = useState("Warning");

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [severity, setSeverity] = useState('success');

    //Autocomplete
    const [employeeObj, setEmployeeObj] = useState('');
    const [employeeText, setEmployeeText] = useState('');

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);


    const handleChangeEmployee = (event, newValue) => {
      //  console.log(newValue);
        setEmployeeObj(newValue ? newValue : []);
        setEmployeeText(newValue ? newValue.empName : "");
        setemployeeValue(newValue ? newValue.employeeId : 0);
    };
    const handleChangeEmployeeInput = (event, newInputValue) => {
        setEmployeeText(newInputValue ? newInputValue : " ");
    };

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function handleCloseWarning() {
        setopenWarning(false);
    }

    //function getURLParameter(sParam) {
    //    var sPageURL = window.location.search.substring(1);
    //    var sURLVariables = sPageURL.split('&');
    //    for (var i = 0; i < sURLVariables.length; i++) {
    //        var sParameterName = sURLVariables[i].split('=');
    //        var value = '';
    //        for (var j = 0; j < sParameterName.length; j++) {
    //            if (sParameterName[j] == sParam) {
    //                for (var k = j + 1; k < sParameterName.length; k++) {
    //                    value = value + sParameterName[k];
    //                }
    //                break;
    //            }
    //            else {
    //                continue;
    //            }
    //        }
    //        return value;
    //    }       
    //}
    const tableHeaderStyle = {
        backgroundColor: "var(--light-sand)",
        color: "var(--dark-blue)",
    };
    const tableOptions = {
        headerStyle: tableHeaderStyle,
        showTitle: false,
        draggable: false,
        pageSize: 5,
        pageSizeOptions: [5, 10, 25, 50],
        paginationPosition: "bottom",
        //paging: false,
        maxBodyHeight: '600px',
        // exportButton: true,
        // exportAllData: true
    };
    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }
    function GetEditButton(rowData) {
        return (
            <Tooltip title="Modify Slip" placement="bottom">
                <span>
                    <Button href="javascript:void(0)">
                        <span>
                            <EditOutlinedIcon fontSize="small" className="attachFileIcon" />
                        </span>
                    </Button>
                </span>
            </Tooltip>
        );
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }

    const today = Date.now();
    let newdateformat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(today);
    let ldate = newdateformat.split("/")[2] + "-" + newdateformat.split("/")[0] + "-" + newdateformat.split("/")[1];
    const [entrydate, setentrydate] = useState(ldate);
    const [isDisabled, setisDisabled] = useState(true);
    const [employee, setemployee] = useState([]);
    const [employeeValue, setemployeeValue] = useState("");
    //const [employeeNameValue, setEmployeeNameValue] = useState("");
    //const [employeeNames, setEmployeeNames] = useState([]);
    const [mrp, setmrp] = useState([]);
    const [time, settime] = useState([]);
    const [date, setdate] = useState([]);
    const [mrpValue, setmrpValue] = useState('');
    const [shiftValue, setshiftValue] = useState('');
    const [slipGenId, setslipGenId] = useState(window.atob(getURLParameter("ID")) ? window.atob(getURLParameter("ID")) : props.SlipGenId);
    const [EntryNumberValue, setEntryNumberValue] = useState("");
    const [ViewEntryNumberValue, setViewEntryNumberValue] = useState("");
    const [WorkerShift, setWorkerShift] = useState([]);
    const [EnteredTimeValue, setEnteredTimeValue] = useState("");
    const [InputTimeValue, setInputTimeValue] = useState("");
    const [IdleTimeValue, setIdleTimeValue] = useState("");
    const [EfficiencyValue, setEfficiencyValue] = useState("");
    const [slipDataDetails, setslipDataDetails] = useState([]);
    const [slipDataPlanTime, setslipDataPlanTime] = useState([]);
    const [slipDataUnPlanTime, setslipDataUnPlanTime] = useState([]);
    const [slipDataIHFTime, setslipDataIHFTime] = useState([]);
    const [PlanTimeValue, setPlanTimeValue] = useState([]);
    const [UnPlanTimeValue, setUnPlanTimeValue] = useState([]);
    const [IHFTimeValue, setIHFTimeValue] = useState([]);
    const [NoWorkValue, setNoWorkValue] = useState(0);
    const [CreatedBy, setCreatedBy] = useState(props.loginuser.response.firstName + ' ' + props.loginuser.response.lastName);
    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);
    const [isSubmitDisabled, setisSubmitDisabled] = useState(true);
    const [ViewEfficiencyValue, setViewEfficiencyValue] = useState("");
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    //const [alertsuccess, setalertsuccess] = useState("Success");
    //const [alerterror, setalerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");
    //new
    const [Remarks, setRemarks] = useState("");
    const [place, setPlace] = useState([]);   
    const [loc, setLoc] = useState("");
    const [matNo, setMatNo] = useState("");
    const [matDesc, setMatDesc] = useState("");
    const [classification, setClassification] = useState("");
    const [unit, setUnit] = useState("");
    const [physical, setPhysical] = useState("");
    //Audit slip
    const [slipNumber, setSlipnumber] = useState('');    
    const [auditSlipNumber, setAuditSlipNumber] = useState('');
    const [plant, setPlant] = useState([]);
    const [placeValue, setPlaceValue] = useState("");
    const [phyInvlocation, setphyInvlocation] = useState([]);
    const [phyInvlocationName, setphyInvlocationName] = useState('');
    const [phyInvlocationID, setphyInvlocationID] = useState('');
    const [phyInvlocationObj, setphyInvlocationObj] = useState('');
    const [phyInvMaterial, setphyInvMaterial] = useState([]);
    const [phyInvMaterialName, setphyInvMaterialName] = useState('');
    const [phyInvMaterialID, setphyInvMaterialID] = useState('');
    const [phyInvMaterialObj, setphyInvMaterialObj] = useState('');
    const [viewSlipData, setviewSlipData] = useState([]);

    

    //new handles
  
    const handleRemarksChange = (event) => {
        setRemarks(event.target.value);
    };
    const handleLoc = (event) => {
        setLoc(event.target.value);
    }
    const handleMatNo = (event) => {
        setMatNo(event.target.value);
    }
    const handleMatDesc = (event) => {
        setMatDesc(event.target.value);
    }
    const handleClassification = (event) => {
        setClassification(event.target.value);
    }
    const handleUnit = (event) => {
        setUnit(event.target.value);
    }
    const handlePhysical = (event) => {
        setPhysical(event.target.value);
    }
    //const handleChangeEmp = (event) => {
    //    setemployeeValue(event.target.value);
    //};

    const handleChangeMrp = (event) => {
        setmrpValue(event.target.value);
    };

    const handleChangeShift = (event) => {
        setshiftValue(event.target.value);
    };

//handle audit slip
    
    const handleAuditSlipNumber = (event) => {
        setAuditSlipNumber(event.target.value);
    };
    
    const handleslipNumber = (event) => {
        setSlipnumber(event.target.value);
    };

    const handlePlace = async (event) => {
        setPlaceValue(event.target.value);
        await BindMaterialDetails(event.target.value);
        getLocation(event.target.value);
        BindMaterialDetails(event.target.value);

    }

    const handleChangephyInvlocation = async (event, newValue) => {
        setphyInvlocationObj(newValue ? newValue : []);
        setphyInvlocationName(newValue ? newValue.locationName : "");
        setphyInvlocationID(newValue ? newValue.locationId : 0);
        

    };
    const handleChangephyInvlocationInput = (event, newInputValue) => {
        setphyInvlocationName(newInputValue ? newInputValue : "");
    };

    const handleChangephyInvMaterial = async (event, newValue) => {
       // console.log("newValue", newValue);
        setphyInvMaterialObj(newValue ? newValue : []);
        setphyInvMaterialName(newValue ? newValue.material : "");
        setphyInvMaterialID(newValue ? newValue.materialId : 0);
        
    };
    const handleChangephyInvMaterialInput = (event, newInputValue) => {
        setphyInvMaterialName(newInputValue ? newInputValue : "");
    };


    const loca = ['Hyderabad', 'Pune', 'Mumbai', 'Delhi', 'Thane'


    ];
    const mat = ['1234', '3456', '4567', '5678'];









    function calculateEfficiency_manual(enteredTimeValue, inputTimeValue, idleTimeValue, noWorkValue) {
        //let idletime = ((inputTimeValue - idleTimeValue) + noWorkValue);
        let idletime = inputTimeValue - idleTimeValue - noWorkValue;
        let efficiency = 0;
        if (inputTimeValue > idleTimeValue) {
            efficiency = enteredTimeValue / idletime;
            efficiency = efficiency * 100;
            efficiency = efficiency.toFixed(2);
        }
        setEfficiencyValue(efficiency.toString());
        setViewEfficiencyValue(efficiency.toString() + '%');
    }

    function calculateEfficiency() {
        //let idletime = ((InputTimeValue - IdleTimeValue) + NoWorkValue);
        let idletime = InputTimeValue - IdleTimeValue - NoWorkValue;
        let efficiency = 0;
        if (InputTimeValue > IdleTimeValue) {
            efficiency = EnteredTimeValue / idletime;
            efficiency = efficiency * 100;
            efficiency = efficiency.toFixed(2);
        }
        setEfficiencyValue(efficiency.toString());
        setViewEfficiencyValue(efficiency.toString() + '%');
    }
    function clickEditHardCodeMaster(rowData) {
        //let id = rowData.hardCodeId;
        //let idEncrypted = btoaSecure(id);
        window.location.href = "/UpdateSlipInventory";
    }

    function handleClose() {
        setopen(false);
    }
    function showMessage(errorList, flag, severity) {
        setErrorMessages(errorList);
        setIserror(flag);
        setSeverity(severity);
    }

    //NEW FUNCS
    async function GetViewAuditSlipDetails() {
        let isValidate = true;
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = [];
        if (placeValue == "" || placeValue === null || placeValue === undefined) {
            isValidate = false;
            errorList.push("Select Plant Name");
            showMessage(errorList, true, 'error');
        }
        if (isValidate) {

            setopenLoader(true);
            let slipparam = {
                PlantId: Number(placeValue),
                LocationId: Number(phyInvlocationID),
                MaterialId: Number(phyInvMaterialID),
                CreatedBy: Number(employeeValue),
                AuditSlipNumber: auditSlipNumber,
                SlipNumber: slipNumber
            }
            await apiSlip.post("/getViewAuditSlipDetails/", slipparam,{headers: headers})
                .then(res => {
                    if (res.data.combinationavalialble == 0 && res.data.plantvaluesavailable == 1 && res.data.getresult.length <= 0) {
                        setviewSlipData([]);
                        errorList.push("This plant has no data available");
                        showMessage(errorList, true, 'error');
                        setPlaceValue("");
                        setphyInvlocationName("");
                        setphyInvMaterialName("");
                        setphyInvMaterialID("");

                    }
                    else if (res.data.combinationavalialble == 0 && res.data.plantvaluesavailable == 0 && res.data.getresult.length <= 0) {
                        setviewSlipData([]);
                        errorList.push("This plant has no active workflow");
                        showMessage(errorList, true, 'error');
                        setPlaceValue("");
                        setphyInvlocationName("");
                        setphyInvMaterialName("");
                        setphyInvMaterialID("");
                    }
                    else {
                        //newly added
                        setviewSlipData(res.data.getresult);
                      //  console.log("viewSlip", res.data);
                    }
                    setopenLoader(false);
                })
                .catch(error => {
                    console.log("Error in hitting api : SlipGenDetails")
                    setopenLoader(false);
                })
        }
    }
  
    function clear() {
        setPlaceValue("");
        setphyInvlocationName("");
        setphyInvlocationID("");
        setphyInvlocationObj("");
        setphyInvMaterial([]);
        setphyInvMaterialName("");
        setphyInvMaterialID("");
        setphyInvMaterialObj("");
        setEmployeeObj("");
        setemployeeValue("");
        setEmployeeText("");
        setSlipnumber("");
        setAuditSlipNumber("");
    }

    async function Refresh() {
        await GetViewAuditSlipDetails();
    }


    useEffect(() => {

        getPlant(props.loginuser.response.gid);
        //getLocation();
        getEmployees(0);
    }, []);

    async function getEmployees(id) {
        setemployee([]);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        await api.get('/getAllEmployeeWorkers/',{
            headers: headers,
        })
            .then(res => {                
                setemployee(res.data);
                console.log("EMP Details", res.data);
                //let empData = [];
                //if (id > 0) {
                //    empData = res.data;
                //    empData.filter(x => x.employeeId == id).map(filtered => {
                //        console.log(filtered);
                //        setEmployeeObj(filtered);
                //        setEmployeeText(filtered.empName ? filtered.empName : "");
                //    });
                //}
            })
            .catch(error => {
                console.log("Error in hitting api at page load. Employee")
            })
    }
    //Plant Id field
    async function getPlant(Id) {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        await api.get('/getTblMstPlant/'+Id,{
            headers: headers,
        })
            .then(res => {
                setPlant(res.data);
              //  console.log("Hi",res.data);
                setopenLoader(false);

            })
            .catch(error => {
                console.log("Error in hitting api at page load. MRP Controller")
                setopenLoader(false);

            })
    }

    async function getLocation(plantId) {
        setopenLoader(true);
        let errorList = [];
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        await api.get('/getPhyInvAllLocation/' + plantId,
        {headers: headers})
            .then(res => {
                if (res.data.length <= 0) {
                    errorList.push("This plant has no active workflow");
                    showMessage(errorList, true, 'error');

                    setviewSlipData([]);
                    setPlaceValue("");
                    setphyInvlocationName("");
                    setphyInvMaterialName("");
                    setphyInvMaterialID("");
                }

                setphyInvlocation(res.data);
               // console.log("Hey", res.data);
                setopenLoader(false);

            })
            .catch(error => {
                console.log("Error in hitting api at page load. MRP Controller")
                setopenLoader(false);

            })
    }

    async function BindMaterialDetails(plantId) {
        setopenLoader(true);
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = [];
        let PhyInvInputData = {
            plantId: Number(plantId),
        }

        api.post('/GetPhyInvMaterialNo/', PhyInvInputData,{ headers: headers})
            .then(res => {
                if (res.data.length <= 0) {
                    errorList.push("This plant has no active workflow");
                    showMessage(errorList, true, 'error');
                    setviewSlipData([]);
                    setPlaceValue("");
                    setphyInvMaterialName("");
                    setphyInvMaterialID("");
                }

                setphyInvMaterial(res.data);
               // console.log("MaterialDetails", res.data);
                setopenLoader(false);


            })
            .catch(error => {
                console.log("Error in hitting api at page load. PhyInvLocation");
                setopenLoader(false);

            })
    }


    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">View Audit Slips </h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">

                        <TextField className="lightInputFields  "
                            select
                            id="combo-box-demo"
                            label="Plant Id"
                            variant="filled"
                            fullWidth
                            name=""
                            value={placeValue}
                            onChange={handlePlace}
                        >

                            {
                                plant.map((h, i) =>
                                    (<MenuItem key={i} value={h.plantId}>{h.plantName}</MenuItem>))
                            }


                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex mt-1 Width-100 mt-1 mt-1">
                        {/*<TextField className="lightInputFields  "*/}
                        {/*    //id="CreatedDate"*/}
                        {/*    //disabled={true}*/}
                        {/*    select*/}
                        {/*    label="Location"*/}
                        {/*    variant="filled"*/}
                        {/*    fullWidth*/}
                        {/*    // name="Created Date"*/}
                        {/*    value={loc}*/}
                        {/*    onChange={handleLoc}*/}
                        {/*>*/}
                        {/*    <MenuItem value="">*/}
                        {/*        <em>Select</em>*/}
                        {/*    </MenuItem>*/}
                        {/*    <MenuItem value={10}>Ten</MenuItem>*/}
                        {/*    <MenuItem value={20}>Twenty</MenuItem>*/}
                        {/*    <MenuItem value={30}>Thirty</MenuItem>*/}
                        {/*</TextField>*/}

                        <Autocomplete className="lightInputFields"
                            //disablePortal
                            id="combo-box-demo"
                            value={phyInvlocationObj}
                            inputValue={phyInvlocationName}
                            options={phyInvlocation}
                            getOptionLabel={option => option.locationName ? option.locationName : ""}
                            onChange={handleChangephyInvlocation}
                            onInputChange={handleChangephyInvlocationInput}
                            // sx={{ width: 300 }}
                            renderInput={(params) => <TextField {...params} label="Location Code" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1">

                        <Autocomplete className="lightInputFields"
                            //disablePortal
                            id="combo-box-demo"
                            value={phyInvMaterialObj}
                            inputValue={phyInvMaterialName}
                            options={phyInvMaterial}
                            getOptionLabel={option => option.materialName ? option.materialName : ""}
                            onChange={handleChangephyInvMaterial}
                            onInputChange={handleChangephyInvMaterialInput}
                            // sx={{ width: 300 }}
                            renderInput={(params) => <TextField {...params} label="Material Number" />}
                        />
                    </Grid>

                    <Grid item xs={12} sm={3} className="d-flex Width-100  mt-1">

                        <Autocomplete
                            className="lightInputFields"
                            id="combo-box-demo"
                            fullWidth
                            value={employeeObj}
                            inputValue={employeeText}
                            options={employee}
                            getOptionLabel={option => option.empName ? option.empName : ""}
                            onChange={handleChangeEmployee}
                            onInputChange={handleChangeEmployeeInput}
                            renderInput={
                                (params) =>
                                    <TextField {...params}
                                        label="Slip Audited By"
                                    //required
                                    //error={errorsupervisoryOrganization}
                                    //helperText={errorTextsupervisoryOrganization}
                                    />
                            }
                        //disabled={props.disableValue}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1 ">
                        <TextField className="lightInputFields"
                            //id="CreatedTime"
                            //disabled={true}
                            label="Audit Slip Number"
                            variant="filled"
                            fullWidth
                            //name="Created Time"
                            value={auditSlipNumber}
                            onChange={handleAuditSlipNumber}
                        />



                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100 mt-1 ">
                        <TextField className="lightInputFields"
                            //id="CreatedTime"
                            //disabled={true}
                            label="User Slip Number"
                            variant="filled"
                            fullWidth
                            //name="Created Time"
                            value={slipNumber}
                            onChange={handleslipNumber}
                        />

                    </Grid>

                    <Dialog
                        open={openLoader}
                        //onClose={handleClose}
                        aria-labelledby="draggable-dialog-title"
                        id="templateUploadSuccess"
                        PaperProps={{
                            style: {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                borderColor: "transparent"
                            },
                        }}>
                        <DialogContent>
                            <CircularProgress />
                        </DialogContent>
                    </Dialog>
                    
                  

                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={4} className="d-flex jc-center width-100">

                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={Refresh} >
                            <span>Refresh</span>
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={clear} >
                            <span>Reset</span>
                        </Button>
                    </Grid>
                    {/*<Grid item xs={12} sm={2} className="d-flex jc-center width-100">
                        <Button className="ns-btn-primary mt-1 mr-1" onClick={GetViewAuditSlipDetails}  >
                           <span>Search</span>
                        </Button>
                    </Grid>*/}
                    <Grid item xs={12} sm={3} className="d-flex jc-center width-100">
                    </Grid>

                </Grid>
                <Grid container >
                    <Grid item xs={12}  >
                        <MaterialTable
                            title=""
                            columns={columns}
                            data={viewSlipData}
                            //align={CenterFocusStrong}
                            icons={tableIconsInputScreen}

                            
                            options={{
                                exportButton: {
                                    csv: true,
                                    pdf: false
                                },
                                exportAllData: true,
                                exportFileName: "ViewAuditSlip",
                                pageSize: 50,
                                pageSizeOptions: [50, 75, 100],
                                search: false,


                            }}



                        />

                    </Grid>
                </Grid>



            </div>
        </ThemeProvider>
    );
}


